if (!customElements.get('v6-navigation')) {
  customElements.define('v6-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.menu = this.querySelector('details');
      this.toggle = this.menu.querySelector('summary');
      const close = (restoreFocus = false) => {
        this.menu.open = false;
        if (restoreFocus) this.toggle.focus();
      };
      this.menu.addEventListener('toggle', () => {
        this.toggle.setAttribute('aria-expanded', String(this.menu.open));
      }, { signal });
      this.querySelector('[data-v6-close]').addEventListener('click', () => close(true), { signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.menu.open) {
          event.preventDefault();
          event.stopPropagation();
          close(true);
        }
      }, { signal });
      document.addEventListener('click', event => {
        if (this.menu.open && !this.contains(event.target)) close();
      }, { signal });
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) close();
      }, { signal });
      this.querySelectorAll('.v6-header__links a').forEach(link => {
        link.addEventListener('click', () => close(), { signal });
      });
      const handoffCartFocus = () => {
        this.toggle.setAttribute('aria-expanded', 'false');
        window.requestAnimationFrame(() => {
          close();
          document.querySelector('cart-drawer')?.setActiveElement?.(this.toggle);
        });
      };
      this.querySelector('.v6-header__cart')?.addEventListener('click', handoffCartFocus, { signal });
      this.querySelector('.v6-header__cart')?.addEventListener('keydown', event => {
        if (event.code === 'Space') handoffCartFocus();
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
